import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";

const HREFLANG = { pt: "pt-BR", es: "es", en: "en", it: "it" };
const OG_LOCALE = { pt: "pt_BR", es: "es_ES", en: "en_US", it: "it_IT" };

// Metadatos dinamicos por pagina e idioma + hreflang + Open Graph + JSON-LD.
// title/description pueden venir por props (paginas dinamicas) o del diccionario seo.<page>.*.
export default function Seo({ page, title, description, image, jsonLd = [] }) {
  const { lang, t } = useLang();
  const { pathname } = useLocation();
  const origin = process.env.REACT_APP_SITE_URL || window.location.origin;
  const ttl = title || t(`seo.${page}.title`);
  const desc = description || t(`seo.${page}.description`);
  const url = `${origin}${pathname}`;
  const img = image || `${origin}/brand/og-image.jpg`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{ttl}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {Object.entries(HREFLANG).map(([l, hl]) => (
        <link key={l} rel="alternate" hrefLang={hl} href={`${url}?lang=${l}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="WYD personal travelling" />
      <meta property="og:title" content={ttl} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content={OG_LOCALE[lang] || "pt_BR"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ttl} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
